import React, { Component } from 'react';
import { Navbar, Nav } from 'react-bootstrap'
import { Link } from "react-router-dom"
import { connect } from 'react-redux';
import { setUser, logoutUser } from '../actions/userActions'
import Axios from 'axios';
class TopNav extends Component {
    state = {
        expanded: false,
        actionCount: 0
    }
    logout = () => {
        this.props.logoutUser()
        window.location.href = '/'
    }
    toggle = () => {
        this.setState({ expanded: !this.state.expanded })
    }
    componentDidMount(){
        Axios.get("/api/actions/get/count").then(res=>{
            this.setState({actionCount: res.data.count})
        })
    }
    render() {
        return (
            <div>
                <Navbar expanded={this.state.expanded} onToggle={this.toggle} expand='md' bg="dark" variant="dark" fixed='top'>
                    <Navbar.Brand href="https://breezelabs.co.uk" ><img alt='logo' style={{ width: '150px', paddingTop: '15px' }} src={require('../logo.png')}></img></Navbar.Brand>
                    <div style={{ marginRight: 'auto' }}><Navbar.Brand as={Link} to="/">CNCBreeze</Navbar.Brand></div>
                    <Navbar.Toggle />
                    <Navbar.Collapse >

                        <Nav style={{ width: '100%' }} className="justify-content-end">
                            <Nav.Link as={Link} onClick={this.toggle} to="/print">Print</Nav.Link>

                            {this.props.user ?
                                <>
                                    <Nav.Link as={Link} onClick={this.toggle} to="/orders">Orders</Nav.Link>
                                    <Nav.Link as={Link} onClick={this.toggle} to="/account">Account</Nav.Link>
                                    {this.props.user.admin === true &&
                                        <Nav.Link onClick={this.toggle} as={Link} to="/admin">Admin ({this.state.actionCount})</Nav.Link>
                                    }
                                    <Nav.Link onClick={() => { this.logout(); this.toggle() }}>Logout</Nav.Link>
                                </>
                                :
                                <>
                                    <Nav.Link as={Link} onClick={this.toggle} to="/login">Login</Nav.Link>
                                    <Nav.Link as={Link} onClick={this.toggle} to="/create-account">Create Account</Nav.Link>
                                </>
                            }
                            <Nav.Link as={Link} onClick={this.toggle} to="/help">Help</Nav.Link>

                        </Nav>

                    </Navbar.Collapse>
                </Navbar>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setUser: (data) => { dispatch(setUser(data)) },
        logoutUser: () => { dispatch(logoutUser()) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TopNav);
